import { useQuery } from '@tanstack/react-query';
import { useParams } from '@/providers/RouterShim';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';

export const BRANCH_HIERARCHY_QUERY = '/api/organisation/branches/:branchId/hierarchy';

interface BranchChild {
  id: string;
  name: string;
  children: BranchChild[];
}

export interface BranchHierachy {
  id: string;
  name: string;
  children: BranchChild[];
}

const useBranchHierachy = (): [BranchHierachy | undefined, RequestStateQuery] => {
  const { branchId } = useParams();
  const { getToken, decodedToken } = useAuth();

  const enabled = !!branchId && !!decodedToken?.['belongs-to-branch']?.includes(branchId);

  const { data, isPending, isSuccess, isError } = useQuery<ApiResponse<BranchHierachy>>({
    queryKey: [BRANCH_HIERARCHY_QUERY, branchId],
    queryFn: async () =>
      await getJSON<ApiResponse<BranchHierachy>>(
        `/api/organisation/branches/${branchId}/hierarchy`,
        getToken()!,
      ),
    enabled,
  });
  return [data?.response, { isLoading: isPending, isSuccess, isError }];
};

export default useBranchHierachy;
